import athenaConfig from '../config';

const ENROLLMENT_COMPLETE_MESSAGE = 'mfa factor enrolled from ohsw';
const ENROLLMENT_ABORTED_MESSAGE = 'mfa factor enrollment aborted from ohsw';

const resolveAnetUserProfileAOneBaseUrl = (): string => {
  const { anetUserProfileAOneBaseUrls, aOneBaseUrl } = athenaConfig;
  if (!anetUserProfileAOneBaseUrls) return aOneBaseUrl;
  const clientId = new URLSearchParams(window.location.search).get('clientId');
  return (clientId && anetUserProfileAOneBaseUrls[clientId]) || aOneBaseUrl;
};

export function launchedFromAthenanetUserProfile() {
  const { manageFactorValue, clientIdParam } = AthenanetUserProfileLaunchedParams();
  return !!(
    manageFactorValue === 'true' &&
    clientIdParam &&
    athenaConfig?.anetUserProfileClientId?.includes(clientIdParam)
  );
}

export function AthenanetUserProfileLaunchedParams() {
  const queryParams = new URLSearchParams(window.location.search);

  const manageFactorValue = queryParams.get('manageFactor');
  const clientIdParam = queryParams.get('clientId');
  return { manageFactorValue, clientIdParam };
}

export function sendNoticeToParentWindow() {
  const targetOrigin = resolveAnetUserProfileAOneBaseUrl();
  // Send to parent window for iframe mode
  if (window?.parent) {
    window.parent.postMessage(ENROLLMENT_COMPLETE_MESSAGE, targetOrigin);
  }

  // Send to opener window for popup mode
  if (window?.opener) {
    window.opener.postMessage(ENROLLMENT_COMPLETE_MESSAGE, targetOrigin);
  }
}

export function sendEnrollmentAbortedNoticeToParentWindow() {
  const targetOrigin = resolveAnetUserProfileAOneBaseUrl();
  // Send to parent window for iframe mode
  if (window?.parent) {
    window.parent.postMessage(ENROLLMENT_ABORTED_MESSAGE, targetOrigin);
  }

  // Send to opener window for popup mode
  if (window?.opener) {
    window.opener.postMessage(ENROLLMENT_ABORTED_MESSAGE, targetOrigin);
  }
}
